import { render } from "./EnumDisplay.vue?vue&type=template&id=fe5d85e2"
import script from "./EnumDisplay.vue?vue&type=script&lang=js"
export * from "./EnumDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__